import getFormattedTime from '@helpers/getFormattedTime'

/**
 * @param {number} timezone временная зона локации
 * @param {number} additionalOffset дополнительные мс для timestamp
 * @returns {{date: number, clearedDate: number, time: (string|*), isOtherTimezone: boolean}}
 */
const getCurrentDateObj = (timezone = 0, additionalOffset = 0) => {
  const date = new Date()
  const userTimeZone = date.getTimezoneOffset() / -60
  const selectedCityTimeZone = timezone + 3
  const offset = 3600000 * -(userTimeZone - selectedCityTimeZone) + additionalOffset
  const dateWithOffset = new Date(date.getTime() + offset)

  return {
    /** @example '22:00' */
    time: getFormattedTime(dateWithOffset),
    date: dateWithOffset.getTime(),
    /** текущая очищенная дата, всё по 0 */
    clearedDate: (function () {
      dateWithOffset.setHours(0, 0, 0, 0)
      return dateWithOffset.getTime()
    })(),
    isOtherTimezone: +offset !== 0,
  }
}

export default getCurrentDateObj
